import type { ConstructionItem } from './ConstructionItem';
import type {
  DealConstructionBase,
  DealConstructionContext,
  DealConstructionContextBase
} from './DealConstruction';
import type { DealEstimation, DealEstimationContext } from './DealEstimate';

export type OperationType = 'add' | 'edit' | 'delete' | 'copy';

export type DealEstimationHistory = DealConstructionBase & {
  constructionItem: ConstructionItem;
  dealEstimation: DealEstimation | null;
  operationType: OperationType;
  type: 'DealEstimationHistory';
};

export type DealEstimationHistoryContext = DealConstructionContextBase & {
  managementFee: number;
  vendorFee: number;
  dealEstimationHeaderId: number | null;
  note: string | null;
  noteModified: boolean;
  type: 'DealEstimationHistoryContext';
};

export const historyConstructionContext = (
  requestHistoryContext: DealEstimationHistoryContext | null,
  estimationHistoryContext: DealEstimationHistoryContext
): DealConstructionContext | null => {
  if (requestHistoryContext) return requestHistoryContext;
  // 配列で返ってくるので、lengthで確認する
  if (
    estimationHistoryContext &&
    estimationHistoryContext.dealConstructions.length > 0
  ) {
    return estimationHistoryContext;
  }
  return null;
};

// 一覧を表示するために最新のcontextを取得する
export const estimationConstructionContext = (
  requestHistoryContext: DealEstimationHistoryContext | null,
  estimationHistoryContext: DealEstimationHistoryContext,
  estimationContext: DealEstimationContext
): DealConstructionContext =>
  historyConstructionContext(requestHistoryContext, estimationHistoryContext) ??
  estimationContext;

export const hasDraftEstimations = (
  dealEstimationHistoryContext: DealEstimationHistoryContext
): boolean => dealEstimationHistoryContext.dealConstructions.length !== 0;
